<template>
    <div class="border rounded my-2 px-4 py-3">
        <div class="font-16">
            <div class="custom-control custom-switch">
                <input class="custom-control-input"
                       type="checkbox"
                       :value="enabled"
                       :checked="enabled"
                       :disabled="notAvailable"
                       @change="$emit('toggle')"
                       :id="`enabled-${extension.name}`">
                <label v-tooltip="tooltip"
                       class="custom-control-label"
                       style="padding-top: 2px;"
                       :class="{ 'text-muted': notAvailable }"
                       :for="`enabled-${extension.name}`">
                    {{ extension.label }}
                </label>
            </div>
        </div>
        <div v-html="extension.tooltip" :class="{ 'text-muted': notAvailable }"></div>

        <slot name="footer" :enabled="enabled"></slot>

    </div>
</template>

<script>
export default {
    name: 'FormExtensionsItem',
    props: {
        settings: {
            type: Object,
            required: true
        },
        extension: {
            type: Object,
            required: true
        }
    },
    computed: {
        tooltip() {
            if (this.notAvailable) {
                return {
                    html: true,
                    content: '<div class="text-info">Available if</div>' + this.extension.available.hint
                }
            }
            return ''
        },

        extensions() {
            return this.settings.extensions || []
        },

        enabled() {
            return !!this.extensions.find(e => e.name === this.extension.name)
        },

        notAvailable() {
            return this.extension.available &&
                typeof this.extension.available.validator === 'function' &&
                !this.extension.available.validator(this.settings)
        }
    }
}
</script>
